import script from "./notice.vue?vue&type=script&setup=true&lang=js"
export * from "./notice.vue?vue&type=script&setup=true&lang=js"

import "./notice.vue?vue&type=style&index=0&id=6b115441&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.38_vue@3.4.38_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b115441"]])

export default __exports__